import { aiPanelsPluginKey } from './ai-panels-plugin-key';
import { SafePlugin } from '../local-safe-plugin';
import { getNewlyEditedAIPanels } from './utils';
import { addAnalytics } from '../../analytics/utils';
export const createAIPanelsPlugin = () => {
  return new SafePlugin({
    key: aiPanelsPluginKey,
    state: {
      init: (_, _state) => ({
        editedPanelIds: {}
      }),
      apply: (tr, pluginState) => {
        const meta = tr.getMeta(aiPanelsPluginKey);
        if (!meta || !meta.localIdsPanelTypes) {
          return pluginState;
        }
        const newEditedState = {
          ...pluginState.editedPanelIds,
          ...meta.localIdsPanelTypes
        };
        return {
          ...pluginState,
          editedPanelIds: newEditedState
        };
      }
    },
    appendTransaction: (transactions, _oldState, newState) => {
      let tr = newState.tr;
      let edited = false;
      const aiPluginState = aiPanelsPluginKey.getState(newState);
      const localIdsPanelTypes = getNewlyEditedAIPanels({
        transactions,
        knownEditedPanelIds: aiPluginState.editedPanelIds
      });
      if (Object.keys(localIdsPanelTypes).length) {
        tr = tr.setMeta(aiPanelsPluginKey, {
          localIdsPanelTypes
        });
        edited = true;
        for (const [_, panelTypes] of Object.entries(localIdsPanelTypes)) {
          tr = addAnalytics({
            editorState: newState,
            tr,
            payload: {
              action: 'edited',
              actionSubject: 'editorPluginAI',
              actionSubjectId: 'AIPanels',
              attributes: {
                extensionKey: panelTypes.extensionKey,
                extensionType: panelTypes.extensionType
              },
              eventType: 'ui'
            }
          });
        }
      }
      return edited ? tr : null;
    }
  });
};